import { useContext } from 'react';

import { FullscreenGalleryContext } from './FullscreenGalleryContextTypes';

export const useFullscreenGallery = () => {
  const context = useContext(FullscreenGalleryContext);
  if (!context) {
    // In development, return a safe default instead of throwing to prevent hot reload issues
    if (import.meta.env.DEV) {
      console.warn(
        'useFullscreenGallery used outside of FullscreenGalleryProvider, using default values'
      );
      return {
        isGalleryFullscreen: false,
        setIsGalleryFullscreen: () => {
          console.warn('setIsGalleryFullscreen called but no provider available');
        },
        isLogoLightboxOpen: false,
        setIsLogoLightboxOpen: () => {
          console.warn('setIsLogoLightboxOpen called but no provider available');
        },
      };
    }
    throw new Error('useFullscreenGallery must be used within a FullscreenGalleryProvider');
  }
  return context;
};
